/**
 * @author Apoorva <apoorva.kashyap@314ecorp.com>
 * @description icon for TranscriptSideBarIcon
 */
import clsx from 'clsx';
import React from 'react';

const TranscriptSideBarIcon: React.FC<any> = (props) => {
	const { className, ...restProps } = props;
	const cn = clsx('anticon anticon-icon', className);

	return (
		<span className={cn} aria-label='Transcript' {...restProps}>
			<svg aria-label='Transcript' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M2.55556 1.77783C2.12778 1.77783 1.77778 1.91783 1.45889 2.22117C1.15556 2.5245 1 2.89783 1 3.33339V12.6667C1 13.1023 1.15556 13.4756 1.45889 13.7789C1.77778 14.0823 2.12778 14.2223 2.55556 14.2223H13.4444C13.8333 14.2223 14.2222 14.0745 14.5256 13.7634C14.8444 13.4445 15 13.0789 15 12.6667V3.33339C15 2.92117 14.8444 2.55561 14.5256 2.23672C14.2222 1.92561 13.8333 1.77783 13.4444 1.77783H2.55556ZM2.16667 2.9445H13.8333V13.0556H2.16667V2.9445ZM4.11111 5.66672C3.87778 5.66672 3.69889 5.73672 3.55111 5.8845C3.40333 6.03228 3.33333 6.21117 3.33333 6.4445V9.55561C3.33333 9.78894 3.40333 9.96783 3.55111 10.1156C3.69889 10.2634 3.87778 10.3334 4.11111 10.3334H6.44444C6.65444 10.3334 6.83333 10.2634 6.99667 10.1156C7.15222 9.96783 7.22222 9.78894 7.22222 9.55561V8.77783H6.05556V9.16672H4.5V6.83339H6.05556V7.22228H7.22222V6.4445C7.22222 6.21117 7.15222 6.03228 6.99667 5.8845C6.83333 5.73672 6.65444 5.66672 6.44444 5.66672H4.11111ZM9.55556 5.66672C9.34556 5.66672 9.16667 5.73672 9.00333 5.8845C8.84778 6.03228 8.77778 6.21117 8.77778 6.4445V9.55561C8.77778 9.78894 8.84778 9.96783 9.00333 10.1156C9.16667 10.2634 9.34556 10.3334 9.55556 10.3334H11.8889C12.1222 10.3334 12.3011 10.2634 12.4489 10.1156C12.5967 9.96783 12.6667 9.78894 12.6667 9.55561V8.77783H11.5V9.16672H9.94444V6.83339H11.5V7.22228H12.6667V6.4445C12.6667 6.21117 12.5967 6.03228 12.4489 5.8845C12.3011 5.73672 12.1222 5.66672 11.8889 5.66672H9.55556Z'
					fill='currentColor'
				/>
			</svg>
		</span>
	);
};

export default TranscriptSideBarIcon;
